export function mapAuctionCategory(cat) {
  return {
    id: cat.category_id ?? cat.id,
    name: cat.category_name || cat.name,
    imagePath: cat.image_path || null,
    description: cat.category_description || cat.description || "",
  };
}

export function mapAuctionSubCategory(sub) {
  return {
    id: sub.sub_category_id ?? sub.id,
    name: sub.sub_category_name || sub.name,
    imagePath: sub.image_path || null,
    description: sub.sub_category_description || sub.description || "",
  };
}

export function getAuctionBrowseDepth(applied) {
  if (applied.module !== "auctions") return -1;
  if (!applied.auctionCategory) return 0;
  if (!applied.auctionSubCategory) return 1;
  return 2;
}

export function buildAuctionListingsHref(applied = {}) {
  const next = new URLSearchParams();
  const category = applied.auctionCategory ?? applied.category;
  const subCategory = applied.auctionSubCategory ?? applied.subCategory;
  if (category) next.set("category", String(category));
  if (subCategory) next.set("subCategory", String(subCategory));
  const qs = next.toString();
  return qs ? `/auction?${qs}` : "/auction";
}

export function shouldShowAuctionListings(applied = {}, { subCategoriesLoaded = false, subCategoryCount = 0 } = {}) {
  const q = String(applied.q || "").trim();
  if (q) return true;
  const subCategory = applied.subCategory ?? applied.auctionSubCategory;
  if (subCategory) return true;
  const category = applied.category ?? applied.auctionCategory;
  if (category && subCategoriesLoaded && subCategoryCount === 0) return true;
  return false;
}

export function buildMarketplaceAuctionBrowseHref(params = {}) {
  const next = new URLSearchParams();
  next.set("module", "auctions");
  if (params.auctionCategory) next.set("auctionCategory", String(params.auctionCategory));
  if (params.auctionSubCategory) next.set("auctionSubCategory", String(params.auctionSubCategory));
  return `/marketplace/products?${next.toString()}`;
}

function initStatsEntry() {
  return { auction_count: 0, seller_ids: new Set(), subcategory_count: 0 };
}

export function buildAuctionBrowseStatsIndex(auctions = [], subCategoryCountByCategory = {}) {
  const categoryStats = {};
  const subCategoryStats = {};

  auctions.forEach((auction) => {
    const catId = String(auction.category_id || "");
    const subId = String(auction.sub_category_id || "");
    if (catId) {
      if (!categoryStats[catId]) categoryStats[catId] = initStatsEntry();
      categoryStats[catId].auction_count += 1;
      const sellerId = auction.seller_company_id ?? auction.company_id;
      if (sellerId) categoryStats[catId].seller_ids.add(String(sellerId));
    }
    if (subId) {
      if (!subCategoryStats[subId]) subCategoryStats[subId] = initStatsEntry();
      subCategoryStats[subId].auction_count += 1;
      const sellerId = auction.seller_company_id ?? auction.company_id;
      if (sellerId) subCategoryStats[subId].seller_ids.add(String(sellerId));
    }
  });

  Object.entries(subCategoryCountByCategory).forEach(([catId, count]) => {
    if (!categoryStats[catId]) categoryStats[catId] = initStatsEntry();
    categoryStats[catId].subcategory_count = count;
  });

  const toPlain = (entry) => ({
    auction_count: entry.auction_count,
    seller_count: entry.seller_ids.size,
    subcategory_count: entry.subcategory_count,
  });

  return {
    category: Object.fromEntries(Object.entries(categoryStats).map(([k, v]) => [k, toPlain(v)])),
    subCategory: Object.fromEntries(Object.entries(subCategoryStats).map(([k, v]) => [k, toPlain(v)])),
  };
}

export function enrichAuctionBrowseItems({ items = [], depth = 0, statsIndex = {} }) {
  const statsKey = depth === 0 ? "category" : "subCategory";
  const statsMap = statsIndex[statsKey] || {};

  return items.map((item) => {
    const stats = statsMap[String(item.id)] || {};
    if (depth === 0) {
      return {
        ...item,
        product_count: stats.auction_count ?? 0,
        auction_count: stats.auction_count ?? 0,
        supplier_count: stats.subcategory_count ?? 0,
        buyer_request_count: stats.seller_count ?? 0,
      };
    }
    return {
      ...item,
      product_count: stats.auction_count ?? 0,
      auction_count: stats.auction_count ?? 0,
      supplier_count: stats.seller_count ?? 0,
      buyer_request_count: stats.auction_count ?? 0,
    };
  });
}
